module.exports = __webpack_public_path__ + "img/ground-sea.65a98aad.png";